import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import ReactQuill from 'react-quill';
import "quill-mention";
import 'react-quill/dist/quill.snow.css'
import { useTheme } from '@mui/material';

const Styles = styled.div`
    /* Desactivar traducción automática del navegador */
    .ql-editor {
        translate: no;
    }
    
    /* Asegurar que el contenedor tenga position relative */
    position: relative;
    
    .ql-toolbar{
        padding-bottom: 15px;
    }
    .ql-container{
        border-bottom-left-radius: 0.5em;
        border-bottom-right-radius: 0.5em;
        color: ${props => props.$isDarkMode ? '#e0e0e0' : '#000'};
        position: relative;
    }
    .ql-editor{
        height: 180px;
    }
    .ql-container.ql-snow{
        background: ${props => props.$isDarkMode ? '#1F2A40' : '#fff'};
        border-color: ${props => props.$isDarkMode ? '#3d4a62' : '#ccc'};
    }
    .ql-snow.ql-toolbar {
        display: block;
        background: ${props => props.$isDarkMode ? '#2d3a52' : '#e6f0ff'};
        border-top-left-radius: 0.5em;
        border-top-right-radius: 0.5em;
        position: sticky!important;
        top: 0;
        z-index: 1;
        border-color: ${props => props.$isDarkMode ? '#3d4a62' : '#ccc'};
    }
    .ql-snow .ql-stroke {
        stroke: ${props => props.$isDarkMode ? '#b0bec5' : '#444'};
    }
    .ql-snow .ql-fill {
        fill: ${props => props.$isDarkMode ? '#b0bec5' : '#444'};
    }
    .ql-snow .ql-picker {
        color: ${props => props.$isDarkMode ? '#e0e0e0' : '#444'};
    }
    .ql-snow .ql-picker-options {
        background: ${props => props.$isDarkMode ? '#1F2A40' : '#fff'};
        border-color: ${props => props.$isDarkMode ? '#3d4a62' : '#ccc'};
    }
    
    /* Tooltip/diálogo para insertar links - con z-index muy alto */
    .ql-tooltip {
        z-index: 999999 !important;
        position: fixed !important;
        background: ${props => props.$isDarkMode ? '#1F2A40' : 'white'} !important;
        border: 1px solid ${props => props.$isDarkMode ? '#3d4a62' : '#ccc'} !important;
        box-shadow: 0 8px 24px rgba(0,0,0,0.25) !important;
        padding: 12px 16px !important;
        border-radius: 6px !important;
        left: 50% !important;
        top: 50% !important;
        transform: translate(-50%, -50%) !important;
        color: ${props => props.$isDarkMode ? '#e0e0e0' : '#000'};
    }
    
    /* Mantener el comportamiento por defecto de Quill para ocultar */
    .ql-tooltip.ql-hidden {
        display: none !important;
    }
    
    .ql-tooltip input[type="text"] {
        width: 250px !important;
        padding: 8px 10px !important;
        border: 1px solid ${props => props.$isDarkMode ? '#3d4a62' : '#ccc'} !important;
        border-radius: 4px !important;
        font-size: 14px !important;
        outline: none !important;
        background: ${props => props.$isDarkMode ? '#2d3a52' : '#fff'} !important;
        color: ${props => props.$isDarkMode ? '#e0e0e0' : '#000'} !important;
    }
    
    .ql-tooltip input[type="text"]:focus {
        border-color: ${props => props.$isDarkMode ? '#64B5F6' : '#0364ff'} !important;
        box-shadow: 0 0 0 2px ${props => props.$isDarkMode ? 'rgba(100, 181, 246, 0.1)' : 'rgba(3, 100, 255, 0.1)'} !important;
    }
    .ql-tooltip .ql-action {
        margin-left: 8px !important;
        cursor: pointer !important;
        padding: 4px 12px !important;
        background: #0364ff !important;
        color: white !important;
        border: none !important;
        border-radius: 4px !important;
        font-size: 13px !important;
    }
    .ql-tooltip .ql-remove {
        margin-left: 8px !important;
        cursor: pointer !important;
        padding: 4px 12px !important;
        background: #dc3545 !important;
        color: white !important;
        border: none !important;
        border-radius: 4px !important;
        font-size: 13px !important;
    }
    
    .ql-tooltip .ql-action:hover {
        background: #0246cc !important;
    }
    
    .ql-tooltip .ql-remove:hover {
        background: #bb2d3b !important;
    }
    
    span.mention {
        color: blue;
        background: lightskyblue;
    }
    /* Estilos para los links */
    .ql-editor a {
        color: #0364ff;
        text-decoration: underline;
        cursor: pointer;
    }
    .ql-editor a:hover {
        color: #0246cc;
        text-decoration: underline;
    }
`;

const InputEditQuillSinEtiqueta =({onChangeText,template,id,etiqueta}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [value, setValue] = useState(template || '')

    const modules = useMemo(() => ({
        toolbar: [
            ['bold', 'italic', 'underline','strike'],
            [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
            [{ 'header': [2, 3, false] }],
            [{ 'align': [] }],
            [{ 'color': ['#ff0000', '#00ff00', '#0000ff', '#000000', '#ffffff'], 'default': '#ff0000' }, { 'background': [] }],
            ['clean']
        ],
    }), [])
    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike',
        'list', 'bullet', 'indent','background','color','align','mention'
    ]
    const onChangeTemplete = (newEditor) =>{
        onChangeText(newEditor)
        setValue(newEditor)
    }

    useEffect(() => {
        onChangeText(template)
        setValue(template)
    }, [template])
    return (
        <Styles $isDarkMode={isDarkMode}>
            <ReactQuill
                id={id}
                theme="snow"
                value={value}
                onChange={onChangeTemplete}
                modules={modules}
                formats={formats}
            />
        </Styles>
    )
}

export default InputEditQuillSinEtiqueta